import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';

import './vehicle-history-item.scss';

export function VehicleHistoryItem({ content, description = '', icon }) {
  const [isDescriptionOpen, toggleDescription] = useState(false);
  const isWarning = icon.includes('warning');

  function handleDescriptionClick() {
    toggleDescription(value => !value);
  }

  return (
    <Col xs={6} lg={3} tag="li" className="mb-1">
      <div className="vehicle-history-item d-flex flex-column align-items-center px-1 py-1_5 pos-r h-100 bg-cool-gray-100">
        {description && (
          <Button
            className="info-btn pos-a p-0 border-0"
            onClick={handleDescriptionClick}
            data-tracking-id="view_content"
            data-tracking-value={content}
            aria-label={`Open the description of ${content}`}
          >
            <i className="icon icon-info size-16 text-gray-darker" aria-hidden />
          </Button>
        )}
        <div className="rounded-circle d-flex justify-content-center align-items-center col-auto">
          <i
            className={classnames('icon size-24', `icon-${icon}`, {
              'text-warning': isWarning,
              'text-primary': !isWarning,
            })}
            aria-hidden
          />
        </div>
        <div className="d-flex">
          <h3 className="mt-0_75 mb-0_25 display-lg text-center text-gray-darker">{content}</h3>
        </div>
        {isDescriptionOpen && (
          <div className="description pos-a p-1">
            {description}
            <Button
              className="pos-a p-0 border-0"
              onClick={handleDescriptionClick}
              aria-label={`Close the description of ${content}`}
            >
              <i className="icon icon-cross3" aria-hidden />
            </Button>
          </div>
        )}
      </div>
    </Col>
  );
}

VehicleHistoryItem.propTypes = {
  icon: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  description: PropTypes.string,
};
